import React from "react";
import PropTypes from "prop-types";
import ButtonIcon from "../../components/buttons/buttonIcon";
import * as buttonConstants from "../../components/buttons/buttonConstants";
import ButtonBar from "../../components/buttons/buttonBar";
import * as config from "../../constants/config";
import { getCatModelTypeDescription } from "../../constants/catModelConstants";

const TaskListSearchRow = ({ task, onCatConfigEdit, onEditTask, onDeleteTask }) => {
    const taskLinkList = task.Links.filter(f => f.Method === config.DELETE_API_METHOD);
    let taskLinkInfo = {};
    if(taskLinkList.length > 0)
        taskLinkInfo = taskLinkList[0];

    return (
        <tr>
            <td>{task.Name}</td>
            <td>{task.TaskType}</td>
            <td className={"text-center"}>{task.NumberOfForms}</td>
            <td className={"text-center"}>{getCatModelTypeDescription(task.CatModelType)}</td>
            <td className={"text-center"}>
                <ButtonBar buttonBarPosition={buttonConstants.BUTTON_BAR_POSITION_CENTER}>
                    <ButtonIcon config={{
                        name: "btnCat",
                        label: "CAT",
                        disabled: (task.CatModelType === 0),
                        onClick: (event) => onCatConfigEdit(event, task.Id),
                        iconType: buttonConstants.ICON_CAT
                    }} />
                    <ButtonIcon config={{
                        name: "btnEdit",
                        label: "Edit",
                        onClick: (event) => onEditTask(event, task.Id),
                        iconType: buttonConstants.ICON_EDIT
                    }} />
                    <ButtonIcon config={{
                        name: "btnDelete",
                        label: (taskLinkList.length === 0) ? "Delete not enabled due to being associated with a score" : "Delete",
                        disabled: (taskLinkList.length === 0),
                        onClick: (event) => onDeleteTask(event, taskLinkInfo),
                        iconType: buttonConstants.ICON_DELETE
                    }} />
                </ButtonBar>
            </td>
        </tr>
    );
};

TaskListSearchRow.propTypes = {
    task: PropTypes.object.isRequired,
    onCatConfigEdit: PropTypes.func.isRequired,
    onEditTask: PropTypes.func.isRequired,
    onDeleteTask: PropTypes.func.isRequired
};

export default TaskListSearchRow;